export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGOUT = 'LOGOUT';
export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const GET_PROFILE = 'GET_PROFILE';
export const SET_PROFILE_PROP = 'SET_PROFILE_PROP';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const RESTORE_AUTH = 'RESTORE_AUTH';
export const SET_MODAL = 'SET_MODAL';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const SET_PROTECTED_REFERRER = 'SET_PROTECTED_REFERRER';
export const SET_SYS_LOCALE = 'SET_SYS_LOCALE';
export const VALIDATE_EMAIL = 'VALIDATE_EMAIL';
export const SET_REGISTER_FORM = 'SET_REGISTER_FORM';
export const CLEAR_REGISTER_FORM = 'CLEAR_REGISTER_FORM';
export const SET_VALIDATE_MODAL = 'SET_VALIDATE_MODAL';
export const SEND_REFER = 'SEND_REFER';
export const SEND_VOUCHER_CODE = 'SEND_VOUCHER_CODE';
export const GET_VOUCHERS = 'GET_VOUCHERS';
export const SET_VOUCHERS = 'SET_VOUCHERS';
export const REMOVE_VOUCHER = 'REMOVE_VOUCHER';
export const SET_GUEST_USER = 'SET_GUEST_USER';
export const CLEAR_GUEST_FORM = 'CLEAR_GUEST_FORM';
export const REMOVE_PROFILE = 'REMOVE_PROFILE';
export const SET_FULL_REGISTER_FORM = 'SET_FULL_REGISTER_FORM';
export const UPDATE_PROFILE_IMAGE = 'UPDATE_PROFILE_IMAGE';
export const BUY_REWARD = 'BUY_REWARD';
export const CHECKOUT_DISCOUNT_VOUCHERS = 'CHECKOUT_DISCOUNT_VOUCHERS';
export const CHECKOUT_MULTI_BASKET_DISCOUNT = 'CHECKOUT_MULTI_BASKET_DISCOUNT';
export const GET_GIFT_CARDS = 'GET_GIFT_CARDS';
export const CHECK_VOUCHER_DISCOUNT = 'CHECK_VOUCHER_DISCOUNT';
export const CHECKOUT_TAX_DISCOUNT_VOUCHERS = 'CHECKOUT_TAX_DISCOUNT_VOUCHERS';
export const CHECKOUT_TAX_MULTI_BASKET_DISCOUNT = 'CHECKOUT_TAX_MULTI_BASKET_DISCOUNT';
export const SEND_GIFT_CARD_CODE = 'SEND_GIFT_CARD_CODE';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const READ_NOTIFICATION = 'READ_NOTIFICATION';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';

